const colors = {
    primary: "#FD2D01",
    secondary: "#FFD7D7",
    tertiary: "#4E5166",
    form: "#fc466b",
};

export default colors;
